<app-breadcrumb [master]="'Administracja'" [parentName]="'Chronie'" [name]="'Lista płatności'"></app-breadcrumb>
<div class="chronie-payment-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="row-list-filters">
    <mat-form-field class="chronie-payment-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy"
             [(ngModel)]="initialFilters.policyNumber" name="policyNumber">
    </mat-form-field>
    <mat-form-field class="chronie-payment-list-filter">
      <mat-label>Nazwa klienta</mat-label>
      <input matInput placeholder="Nazwa klienta"
             [(ngModel)]="initialFilters.insuringParty" name="insuringParty">
    </mat-form-field>
    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="chronie-payment-list-filter"
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>

    <app-dict-partners
      class="chronie-payment-list-filter"
      [multiple]="false" [label]="'Partner'"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-datepicker
      class="chronie-payment-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.startCreatedAt" name="startCreatedAt"
    ></app-datepicker>

    <app-datepicker
      class="chronie-payment-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.endCreatedAt" name="endCreatedAt"
    ></app-datepicker>

    <mat-form-field class="chronie-payment-list-filter">
      <mat-label>Kod zniżkowy</mat-label>
      <input matInput placeholder="Kod zniżkowy"
             [(ngModel)]="initialFilters.agentCode" name="agentCode">
    </mat-form-field>
    <app-dict
      [multiple]="false" label="Status"
      class="chronie-payment-list-filter"
      dictType="payment_status"
      [returnKey]="true"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

  </form>

  <div class="chronie-payment-list-buttons">

    <button *ngIf="(userPermissions | async).chronie.read_report"
            [disabled]="!(userPermissions | async).chronie.read_report"
            mat-stroked-button (click)="downloadReport()">
      <mat-icon>download</mat-icon>
      Pobierz raport
    </button>

    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon>
      <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="paymentList" matSort (matSortChange)="sortChanged($event)">
    <ng-container matColumnDef="insuringPartyName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="insuringParty"> Nazwa klienta</th>
      <td mat-cell *matCellDef="let element">
        {{ element.insuringPartyFirstName }} {{ element.insuringPartyLastName }}<br>
       <span style="font-size:10px"> {{ element.insuringPartyEmail }} </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="createdAt"> Data zawarcia</th>
      <td mat-cell *matCellDef="let element">
        {{ element.createdAt | date:'y-MM-dd' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="policyNumber"> Numer polisy</th>
      <td mat-cell *matCellDef="let element">
        {{ element.policyNumber }}
      </td>
    </ng-container>
    <ng-container matColumnDef="agentCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="agentCode"> Kod zniżkowy</th>
      <td mat-cell *matCellDef="let element">
        {{ element.agentCode }}
      </td>
    </ng-container>
    <ng-container matColumnDef="party">
      <th mat-header-cell *matHeaderCellDef> Partner / OFWCA</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner.uuid">
          Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">
          {{ element.partner?.shortName }}
        </a>
        </ng-container>
        <ng-container *ngIf="element.ofwca.uuid">
          <br>
          Ofwca: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">
          {{ element.ofwca?.fullName }}
        </a>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="inkaso">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="sumInsured"> Składka na polisie</th>
      <td mat-cell *matCellDef="let element">
        {{ (element?.sumInsured) | number:'1.2-2' }} zł
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="statusName"> Status płatności</th>
      <td mat-cell *matCellDef="let element">
        <button mat-raised-button
                [style]="'width:100%; color:white; background:' + element.statusColor">{{ element.statusName }}
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="policyDownload">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="(userPermissions | async)?.chronie.read && element.policyNumber && element.policyPdfFile"
             fxLayout="row" fxFlex="100" fxLayoutGap="5px">
          <button *ngIf="(userPermissions | async)?.chronie.admin_root && element.policyNumber"
                  [disabled]="!(userPermissions | async).chronie.admin_root"
                  mat-icon-button color="accent" aria-label=""
                  (click)="downloadFile(element.policyPdfFile)">
            <mat-icon>download</mat-icon>
          </button>
          <button
            [disabled]="!(userPermissions | async).chronie.read"
            mat-icon-button color="primary"
            (click)="sendPolicy(element.uuid, element.insuringPartyFirstName, element.insuringPartyLastName, element.insuringPartyEmail)"
          >
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button
          *ngIf="(userPermissions | async)?.chronie.read_report "
          mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #menu="matMenu" xPosition="before">
          <button
            *ngIf="(userPermissions | async)?.chronie.admin_root"
            [disabled]="element.statusKey !== PAYMENT_STATUS_COMPLETED || (element.policyNumber && element.policyPdfFile)"
            mat-menu-item
            (click)="sendPayU(element.policyUuid, element.periodStart)">
            Wystaw polisę
          </button>
          <button
            *ngIf="(userPermissions | async)?.chronie.read_report"
            [disabled]="!(userPermissions | async)?.chronie.read_report"
            mat-menu-item
            (click)="downloadFile(element.offerPdfFile)">
            Pobierz ofertę
          </button>
          <button
            *ngIf="(userPermissions | async)?.chronie.admin_root"
            [disabled]="!(userPermissions | async)?.chronie.admin_root"
            mat-menu-item
            (click)="downloadFile(element.requestFile)">
            Request
          </button>
          <button
            *ngIf="(userPermissions | async)?.chronie.admin_root"
            [disabled]="!(userPermissions | async)?.chronie.admin_root"
            mat-menu-item
            (click)="downloadFile(element.responseFile)">
            Response
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>

</div>
